(() => {
  const isErgonomicsGuideRoute = window.location.pathname.replace(/\/+$/, '').endsWith('/pages/why-ergonomics');
  const guideRoute = document.querySelector('[data-ergonomics-guide-route]');
  const generic404 = document.querySelector('[data-generic-404]');
  if (isErgonomicsGuideRoute && guideRoute && generic404) {
    guideRoute.hidden = false;
    generic404.hidden = true;
    document.title = `Why Ergonomics — ${document.querySelector('.ergo-brand span:last-child')?.textContent?.trim() || 'My Ergo Chairs'}`;
  }

  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  menuToggle?.addEventListener('click', () => {
    const open = mobileMenu?.classList.toggle('open');
    menuToggle.setAttribute('aria-expanded', String(Boolean(open)));
  });

  const overlay = document.querySelector('[data-fit-overlay]');
  const steps = [...document.querySelectorAll('[data-fit-step]')];
  const progress = document.querySelector('[data-fit-progress]');
  const kicker = document.querySelector('[data-fit-kicker]');
  let step = 0;

  const showStep = (next) => {
    step = Math.max(0, Math.min(next, 3));
    steps.forEach((panel) => panel.hidden = Number(panel.dataset.fitStep) !== step);
    if (progress) progress.style.width = `${Math.min(100, ((step + 1) / 3) * 100)}%`;
    if (kicker) kicker.textContent = step < 3 ? `FIT FINDER · ${step + 1} OF 3` : 'FIT FINDER · RESULT';
  };
  const openFit = () => {
    if (!overlay) return;
    overlay.hidden = false;
    document.body.classList.add('fit-open');
    showStep(0);
    overlay.querySelector('button')?.focus();
  };
  const closeFit = () => {
    if (!overlay) return;
    overlay.hidden = true;
    document.body.classList.remove('fit-open');
  };
  document.querySelectorAll('[data-fit-open]').forEach((button) => button.addEventListener('click', openFit));
  document.querySelector('[data-fit-close]')?.addEventListener('click', closeFit);
  document.querySelectorAll('[data-fit-answer]').forEach((button) => button.addEventListener('click', () => showStep(Math.min(step + 1, 3))));
  overlay?.addEventListener('click', (event) => { if (event.target === overlay) closeFit(); });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeFit(); });

    const mainImage = document.querySelector('.ergo-product-main-image img');
  document.querySelectorAll('[data-product-thumb]').forEach((thumb) => thumb.addEventListener('click', () => {
        if (mainImage && thumb.dataset.productThumb)  { mainImage.removeAttribute('srcset'); mainImage.removeAttribute('sizes'); mainImage.src = thumb.dataset.productThumb; }
  }));

  document.querySelector('[data-sort-select]')?.addEventListener('change', (event) => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', event.target.value);
    window.location.assign(url.toString());
  });
})();
